const { connect } = require('react-redux');
const { context } = require('app-context');
const Signup = require('../components/Signup');
const {
    defaultProspectSignupCopy,
    resolveCustomSignupSlug,
    resolveCustomSignupConfig
} = require('utils/customSignups');
const { getSignupPrefillEmail } = require('services/auth-management/signup-state');

const selectors = context.selectors.all;
const actions   = context.actions;

const internals = {};

internals.isProspectSignup = (match) => {

    const path = match?.path || '';
    const url = match?.url || '';

    return path === '/:slug/prospect' || /\/prospect\/?$/.test(url);
};

module.exports = connect(
    (state, { match }) => {

        const matchSlug = match?.params?.slug;
        const schoolSlug = resolveCustomSignupSlug(matchSlug);
        const signupConfig = resolveCustomSignupConfig(matchSlug);
        const isProspectSignup = internals.isProspectSignup(match);
        const prospectCopy = {
            ...defaultProspectSignupCopy,
            ...(signupConfig?.prospect || {})
        };

        return ({
            schools: null,
            signupDetails: {
                ...selectors.getSignupIdentifyDetails(state),
                schoolId: selectors.getSchoolIdbySlug(state, schoolSlug)
            },
            rememberedEmail: getSignupPrefillEmail({
                identifyContext: selectors.getSignupIdentifyDetails(state),
                signupContext: selectors.getSignupContext(state),
                loginContext: selectors.getLoginContext(state)
            }),
            isCompany: selectors.getSchoolIsCompanyBySlug(state, schoolSlug),
            isCommunity: selectors.getSchoolIsCommunityBySlug(state, schoolSlug),
            showSchoolList: false,
            text: isProspectSignup ? prospectCopy.mainText : signupConfig?.mainText,
            secondaryText: isProspectSignup ? prospectCopy.secondaryText : signupConfig?.secondaryText,
            useWhiteLanding: signupConfig?.useWhiteLanding,
            useWideLogo: signupConfig?.useWideLogo,
            useExtraWideLogo: signupConfig?.useExtraWideLogo,
            logoSidePadding: signupConfig?.logoSidePadding,
            footer: signupConfig?.footer || null,
            logo: selectors.getSchoolLogobySlug(state, schoolSlug),
            isProspectSignup
        });
    },
    {
        onSubmit: actions.signup.identify.complete,
        onInvalidSubmit: actions.signup.identify.failure,
        updateLoginContext: actions.auth.updateLoginContext,
        updateSignupContext: actions.signup.updateContext
    },
    (stateProps, dispatchProps, ownProps) => ({
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        onSubmit: (values) => dispatchProps.onSubmit({
            ...values,
            ...(stateProps.isProspectSignup ? { signupIntent: 'prospect' } : {})
        })
    })
)(Signup);
